import { Component, OnInit } from '@angular/core';
import { CopyleaksServiceHelper } from 'src/app/services/copyleaks.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Attachment, Submission } from 'src/app/models/submission';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { Status } from 'src/app/models/status';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UserTypes } from 'src/app/models/userTypes';
import { HeaderComponent } from '../../header/header.component';
import { NgIf, NgClass, NgFor, DatePipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-compare-select',
    templateUrl: './compare-select.component.html',
    styleUrls: ['./compare-select.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [HeaderComponent, NgIf, MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatIcon, NgClass, NgFor, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class CompareSelectComponent implements OnInit {

  initialAttachmentId: any;
  initialAttachment: Attachment | undefined;
  initialSubmission: Submission | undefined;
  getInitialAttachmentSpinner: boolean = true;

  compareCandidates: Submission[] = [];
  pagedSubmissionList: Submission[] = [];

  studentId: any;
  taskId?: number;
  taskList: any[] = [];

  isEvaluator: boolean = false;
  isAdmin: boolean = false;
  role:UserTypes = UserTypes.EMA;

  //pagination
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageEvent!: PageEvent;

  expandedElement!: Submission | null;

  displayedColumns = ['attempt', 'taskName', 'dateSubmitted', 'submissionId', 'expanded'];

  public StatusEnum = Status;

  constructor(
      private copyLeaksService: CopyleaksServiceHelper,
      private router: Router,
      private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.studentId = this.route.snapshot.params['studentId'];    
    this.initialAttachmentId = this.route.snapshot.params['attachmentId'];
    console.log(this.studentId, this.initialAttachmentId);
    this.getInitialAttachment();
  }

  getInitialAttachment() {
    this.copyLeaksService.getStudentSubmissions(this.studentId, this.role).subscribe(
      res => {
        this.initialSubmission = res.find((submission: any) => {
          this.initialAttachment = submission.attachments.find((x: any) => x.attachmentId.toString() === this.initialAttachmentId);
          return this.initialAttachment;
        });
    
        this.taskId = this.initialSubmission?.taskId;
        this.compareCandidates = res.filter((submission: any) => submission.taskId === this.taskId);
        this.getPagedResults(0);
        this.getInitialAttachmentSpinner = false;
      }
    )
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.getPagedResults(this.pageIndex);
  }

  sortData(sort: any) {
    const data = this.compareCandidates.slice();
    if (!sort.active || sort.direction === '') {
      this.compareCandidates = data;
      return;
    }

    this.compareCandidates = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'dateSubmitted':
          return this.compare(a.dateSubmitted, b.dateSubmitted, isAsc);
        case 'taskName':
          return this.compare(a.taskName, b.taskName, isAsc);
        case 'attempt':
          return this.compare(a.attempt, b.attempt, isAsc);
        case 'submissionId':
          return this.compare(a.submissionId, b.submissionId, isAsc);
        default:
          return 0;
      }
    });

    this.getPagedResults(this.pageIndex);
  }

  getPagedResults(pageNumber: number) {
    this.length = this.compareCandidates.length;
    if(this.compareCandidates.length < this.pageSize) this.pagedSubmissionList = this.compareCandidates;

    let start = pageNumber * this.pageSize;
    let end = start + this.pageSize;
    this.pageIndex = pageNumber;

    this.pagedSubmissionList = this.compareCandidates.slice(start, end);
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  expandedClick(row: any) {
    if(row.attachments){
      this.expandedElement = this.expandedElement === row ? null : row;
      if ( !this.taskList.find(x => x.taskId === row.taskId) ) {
        this.copyLeaksService.getTask(row.taskId,this.role).subscribe(
          res => {
            this.taskList.push(res.task);
            this.checkAttachments(res.task.excludeFileTypes, row);
          }
        )
      }
    }
  }

  checkAttachments(excludeTypes: string, row: Submission) {
    row.attachments.forEach((attachment: Attachment) => {
      //Check file extension
      let fileExt = attachment.title.split('.').pop();
      if( fileExt && excludeTypes.includes(fileExt) ) {
        attachment.excludedType = true;
      }
    });
  }

  navigateToScan(studentId: string, attachmentId: number) {
    console.log(this.initialAttachmentId, attachmentId);

    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    this.copyLeaksService.compareAttachmentFiles(this.initialAttachmentId, attachmentId, this.role).subscribe({
      next: (res) => this.router.navigateByUrl(`/compare/${this.initialAttachmentId}/to/${attachmentId}`),
      error: (error) => {
        if (error.status === 200) {
          this.router.navigateByUrl(`/compare/${this.initialAttachmentId}/to/${attachmentId}`);
        }
      }
    });
  }
}
